module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P12"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/05_LIST_OF_TABLES_AND_FIGURES#page_ix"
    }
  }, [_vm._v("LIST OF TABLES AND FIGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "C187"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_ACKNOWLEDGMENTS#page_xiii"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction__Obesity_and_the_Ne#page_1"
    }
  }, [_vm._v("Introduction: "), _c('em', [_vm._v("Obesity and the Neoliberal Diet")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_1__The_Neoliberal_Food_Regime_an#page_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. The Neoliberal Food Regime and Its Crisis: "), _c('em', [_vm._v("The Dynamic Factors")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_2__Neoregulation_of_Agricultural#page_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Neoregulation of Agricultural Biotechnology at the National and Suprastate Scales")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_3__Food_and_Inequality_in_the_Un#page_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Food and Inequality in the United States")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_4__Class_Diets_in_the_NAFTA_Regi#page_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Class Diets in the NAFTA Region: "), _c('em', [_vm._v("Divergence or Convergence?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_5__NAFTA__Agriculture__and_Work#page_124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. NAFTA, Agriculture, and Work: "), _c('em', [_vm._v("Mexico’s Loss of Food and Labor Sovereignty")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_6__Globalizing_the_Neoliberal_Di#page_150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Globalizing the Neoliberal Diet: "), _c('em', [_vm._v("Food Security and Trade")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_7__Food_Security__Obesity__and_I#page_168",
      "id": "page_viii",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Food Security, Obesity, and Inequality: "), _c('em', [_vm._v("Measuring the Risk of Exposure to the Neoliberal Diet")])])]), _vm._v(" "), _c('p', {
    staticClass: "C187"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Conclusion__What_Is_to_Be_Done#page_187",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: "), _c('em', [_vm._v("What Is to Be Done?")])])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_REFERENCES#page_197",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("REFERENCES")])]), _vm._v(" "), _c('p', {
    staticClass: "C186"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_INDEX#page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDEX")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-942657b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Contents.vue
// module id = 69
// module chunks = 0